import React, { useEffect } from "react";
import Adv_banner from "./adv-banner/Adv_banner";
import Commission from "./commisions/Commission";
import Technical from "./technical/Technical";
import Quick_steps from "./quick-steps/Quick_steps";
import For_support from "../for-support/For_support";

const Advantage = () => {
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Adv_banner />
      <Commission />
      <Technical />
      <Quick_steps />
      <For_support />
    </>
  );
};

export default Advantage;
